import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  createRootRouteWithContext,
  Link,
  Outlet,
} from "@tanstack/react-router";
import { PageTitleProvider } from "../contexts/PageTitleContext";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { AuthContext, useAuth } from "../auth";
import { Navigate } from "@tanstack/react-router";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: AuthContext;
}>()({
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />,
});

function NotFoundPage() {
  const auth = useAuth();
  const { t } = useTranslation();

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" search={{ redirect: window.location.pathname + window.location.search }} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h1" color="primary" sx={{ fontWeight: "bold" }}>
        404
      </Typography>
      <Typography variant="h5" color="text.secondary">
        {t("common.pageNotFound", "Página não encontrada")}
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large">
        {t("common.backToHome", "Voltar ao início")}
      </Button>
    </Box>
  );
}

function RootComponent() {
  return (
    <PageTitleProvider>
      <Outlet />
      <ReactQueryDevtools buttonPosition="bottom-left" />
      <TanStackRouterDevtools position="bottom-left" />
    </PageTitleProvider>
  );
}
